import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const FilterBarWrapper = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: 10,
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  padding: '12px 16px',
  backgroundColor: 'rgba(255,255,255,0.92)',
  backdropFilter: 'blur(10px)',
  borderRadius: 12,
  boxShadow: theme.shadows[1],
  marginBottom: 20,
}));

/* Row 1: tabs + dates + action buttons */
export const TopRow = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 10,
});

export const TabsWrapper = styled(Box)({
  flexShrink: 0,
});

export const ActionsGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginLeft: 'auto',
  flexShrink: 0,
  flexWrap: 'wrap',
});

/* Row 2: filter dropdowns in a compact grid */
export const FiltersGroup = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
  gap: 8,
  width: '100%',
});

export const ChipGroupWrapper = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 6,
  minWidth: 0,
});
